import { render, staticRenderFns } from "./eateryList.vue?vue&type=template&id=d957fc72"
import script from "./eateryList.vue?vue&type=script&lang=js"
export * from "./eateryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports